import { BackendService } from './BackendService';

export type GetCountiesAndCitiesResult = {
  zipcode: string;
  state: string;
  county: string;
  city: string;
}[];

export default class UtilsService {
  static getCountiesAndCities(zipcode: string) {
    return BackendService.get<GetCountiesAndCitiesResult>(
      `/utils/counties-cities/${zipcode}`,
    );
  }
}
